import { api } from 'API/axios';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/MedicationsPdf';

export const getConfirmations = async (docId: string) => {
  const docData = await api.get<{ pdfSource: string }>(
    addImposterToUrl(baseUrl + `/${docId}`, true)
  );
  if (docData.data?.pdfSource) {
    return docData.data.pdfSource;
  }
};
